import * as Yup from "yup";
import { BoletagemSchema } from "../boletagem";
import { BoletagemAnexoTipo } from "./model";

export class BoletagemAnexoSchema {
  public static id() {
    return recordShape.id;
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static create() {
    const {
      boletagem,
      tipo,
    } = recordShape;
    return Yup
      .object()
      .shape({
        boletagem: boletagem.required("Boletagem é obrigatório"),
        tipo: tipo.required("Tipo é obrigatório"),
      });
  }
}

const recordShape = {
  id: Yup
    .number(),
  boletagem: Yup
    .object()
    .shape({
      id: BoletagemSchema.id()
        .required("Boletagem é obrigatório"),
    }),
  tipo: Yup
    .mixed<BoletagemAnexoTipo>()
    .oneOf(
      Object.values(BoletagemAnexoTipo),
      `Tipo deve ser "${Object.values(BoletagemAnexoTipo).join('" ou "')}"`
    ),
};
